import { render } from "./GlobalMessage.vue?vue&type=template&id=340dcfce&scoped=true"
import script from "./GlobalMessage.vue?vue&type=script&lang=js"
export * from "./GlobalMessage.vue?vue&type=script&lang=js"

import "./GlobalMessage.vue?vue&type=style&index=0&id=340dcfce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340dcfce"]])

export default __exports__